import React, { cloneElement } from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';

import styles from './StepBody.styles';

const StepBody = ({
  step,
  index,
  isActive,
  isFinalStep,
  steps,
  onNextStep,
  onSkipStep,
  onPreviousStep,
  renderStepBody,
  additionalProps,
  ...props
}) => {
  const stepBodyWithHandlers = cloneElement(
    renderStepBody(step, index, isActive, isFinalStep, steps),
    {
      onNextStep,
      onSkipStep,
      onPreviousStep,
      index,
      ...additionalProps,
      ...props,
    },
  );

  return (
    <View style={styles.itemContainer} testID={FoundationTestKeys.timelineStepBody}>
      {stepBodyWithHandlers}
    </View>
  );
};

StepBody.propTypes = {
  step: PropTypes.any,
  index: PropTypes.number,
  isActive: PropTypes.bool,
  isFinalStep: PropTypes.bool,
  steps: PropTypes.array,
  onNextStep: PropTypes.func,
  onSkipStep: PropTypes.func,
  onPreviousStep: PropTypes.func,
  renderStepBody: PropTypes.func,
  additionalProps: PropTypes.object,
};

export default StepBody;
